<template>
  <PrimeSelectButton
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :options="options"
    :optionLabel="optionLabel"
    :optionValue="optionValue"
    :allowEmpty="allowEmpty"
    @change="$emit('change', $event)"
  >
    <template v-if="$slots.option" #option="slotProps">
      <slot name="option" v-bind="slotProps"></slot>
    </template>
  </PrimeSelectButton>
</template>

<script setup lang="ts">
import PrimeSelectButton from 'primevue/selectbutton';

withDefaults(defineProps<{
  modelValue?: string | number | object | null;
  options?: any[];
  optionLabel?: string;
  optionValue?: string;
  allowEmpty?: boolean;
}>(), {
  modelValue: null,
  options: () => [],
  optionLabel: undefined,
  optionValue: undefined,
  allowEmpty: true,
});

defineEmits<{
  'update:modelValue': [value: any];
  'change': [event: any];
}>();
</script>
